import { Layout, Spin } from 'antd'
import React from 'react'
import AdminSlotCardTabs from './AdminSlotCardTabs'
import AdminSlotActions from './AdminSlotActions'

export default function AdminSlotCard ({ form, slot, setSlot, loading, setLoading, cancel, back, delay, setIsDirty }) {
  return (
    <Layout style={{ backgroundColor: 'white', padding: '1em 0', fontSize: '24px' }}>
      <Spin spinning={loading}>
        <AdminSlotCardTabs form={form} slot={slot} setSlot={setSlot} loading={loading} setLoading={setLoading} setIsDirty={setIsDirty} />
        <AdminSlotActions form={form} slot={slot} cancel={cancel} back={back} delay={delay} />
      </Spin>
    </Layout>
  )
}
